import React from 'react';
import CropPicture from './CropPicture';

export const Picture = ( props ) => {
    const { url } = props;

    return (
        url ? <CropPicture {...props} /> : null
        // url ? <img className="profile-pic" src={url} alt="profile-pic"/> : null
    )
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/header/picture/Picture.js